import { render, staticRenderFns } from "./public-top-tips.vue?vue&type=template&id=40e193cc&"
import script from "./public-top-tips.vue?vue&type=script&lang=js&"
export * from "./public-top-tips.vue?vue&type=script&lang=js&"
import style0 from "./public-top-tips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports